import PropTypes from "prop-types"
import React from "react"
import styled from 'styled-components'
import { headerColor, headerHeight, headerHeightMd, headerHeightLg, breakpointSmall, breakpointXL } from '../variables'
import SiteBranding from './siteBranding'
import Navigation from './navigation'
import ToggleButton from './toggleButton'

const Header = ({ toggleMobileNav, isMobileNavOpen }) => {
  return (
    <HeaderContainer>
      <SiteBranding />
      <Navigation />
      <ToggleButton toggleMobileNav={toggleMobileNav} isMobileNavOpen={isMobileNavOpen} />
    </HeaderContainer>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header


const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px 0 10px;
  background: ${headerColor};
  height: ${headerHeight};


  @media(min-width: ${breakpointSmall}){
    height: ${headerHeightMd};

  }

  @media(min-width: ${breakpointXL}){
    height: ${headerHeightLg};
    padding: 0 29px 0 7px;
  }
`;